import React from "react";
import { View, StyleSheet } from "react-native";
import BaseMarketingController from "./BaseMarketingController";
import NtMarketingPageContainer from "../components/general/NtMarketingPageContainer";
import NtSectionTitle from "../components/general/NtSectionTitle";
import NtText from "../../components/NtText";
import NtCaseStudyCunard from "../components/casestudy/NtCaseStudyCunard";
import NtCaseStudyHap from "../components/casestudy/NtCaseStudyHap";
import NtCaseStudyDisney from "../components/casestudy/NtCaseStudyDisney";
import NtCaseStudyNcl from "../components/casestudy/NtCaseStudyNcl";
import NtCaseStudyNationalGuard from "../components/casestudy/NtCaseStudyNationalGuard";
import NtCaseStudyNaviCommunication from "../components/casestudy/NtCaseStudyNaviCommunication";
import Logger from "../../common/utils/Logger";
import NtCaseStudyNotFound from "../components/casestudy/NtCaseStudyNotFound";
import NtCaseStudyNaviStrikeGroup from "../components/casestudy/NtCaseStudyNaviStrikeGroup";
import NtCaseStudyAyaya from "../components/casestudy/NtCaseStudyAyaya";
import NtCaseStudyNooz from "../components/casestudy/NtCaseStudyNooz";
import NtCaseStudyTritan from "../components/casestudy/NtCaseStudyTritan";
import NtCaseStudyNoaaShip from "../components/casestudy/NtCaseStudyNoaaShip";

class ImpactStudyController extends BaseMarketingController {
  state = {};

  componentDidUpdate(prevProps) {
    // Check if the params have changed
    if (prevProps.route.params !== this.props.route.params) {
      Logger("Component did Update");
      window.scrollTo({
        top: 0,
        behavior: "smooth", // Optional: for smooth scrolling animation
      });
    }
  }

  renderSection = () => {
    if (this.props.route?.params?.type == "cunard") {
      return <NtCaseStudyCunard />;
    } else if (this.props.route?.params?.type == "holand") {
      return <NtCaseStudyHap />;
    } else if (this.props.route?.params?.type == "disney") {
      return <NtCaseStudyDisney />;
    } else if (this.props.route?.params?.type == "ncl") {
      return <NtCaseStudyNcl />;
    } else if (this.props.route?.params?.type == "national-guard") {
      return <NtCaseStudyNationalGuard />;
    } else if (this.props.route?.params?.type == "navy-communications") {
      return <NtCaseStudyNaviCommunication />;
    } else if (this.props.route?.params?.type == "navi-carrier-strike-group") {
      return <NtCaseStudyNaviStrikeGroup />;
    } else if (this.props.route?.params?.type == "avaya") {
      return <NtCaseStudyAyaya />;
    } else if (this.props.route?.params?.type == "nooz") {
      return <NtCaseStudyNooz />;
    } else if (this.props.route?.params?.type == "tritan") {
      return <NtCaseStudyTritan />;
    } else if (this.props.route?.params?.type == "noaa-ship") {
      return <NtCaseStudyNoaaShip />;
    } else {
      return <NtCaseStudyNotFound />;
    }
  };

  render() {
    return (
      <NtMarketingPageContainer containerStyle={styles.container}>
        {this.renderSection()}
      </NtMarketingPageContainer>
    );
  }
}

const styles = StyleSheet.create({
  container: {},
});

export default ImpactStudyController;
